import Swal from 'sweetalert2';
import HelperMixin from '../../Shared/HelperMixin.vue';
import PaginationHelper from '../../Shared/PaginationHelper.vue';

export default {
    name: 'BranchUsers',
    mixins: [HelperMixin],
    components: { PaginationHelper },

    async created() {
        await this.CheckLoginStatus();
        if (!this.loginDetails || !this.canViewBranchUsersUi()) {
            this.logout();
            return;
        }
        if (this.isAddPage && !this.canCreateBranchUsersUi()) {
            this.$router.replace({ name: 'BranchUsers' });
            return;
        }
        // الوزارة تختار المرفق أولاً؛ ولا تُحمَّل قائمة ولا أقسام قبل اختياره،
        // إذ لا معنى لعرض «كل المستخدمين» لمن ينشئ حساباً في مرفق بعينه.
        if (this.canCreateBranchUsersUi()) {
            await this.loadBranchList();

            const fromUrl = Number((this.$route && this.$route.query && this.$route.query.branchId) || 0);
            if (fromUrl > 0) this.selectedBranchId = fromUrl;

            if (this.isAddPage) {
                // بلا مرفق لا معنى لصفحة الإضافة: الأقسام لا تُحمَّل والحفظ يُرفض.
                if (!this.selectedBranchId) {
                    this.$router.replace({ name: 'BranchUsers' });
                    return;
                }
                await this.loadDepartmentList();
                this.ClearForm(this.ruleForm);
            } else if (this.selectedBranchId) {
                await this.loadDepartmentList();
                this.GetInfo();
            }
            return;
        }

        await this.loadDepartmentList();
        if (this.isAddPage) {
            this.ClearForm(this.ruleForm);
        } else {
            this.GetInfo();
        }
    },

    computed: {
        isAddPage() {
            return (this.$route && this.$route.name) === 'BranchUsersAdd';
        },
        selectedBranchName() {
            const id = Number(this.selectedBranchId || 0);
            if (!id) return '';
            const b = this.branchList.find((x) => Number(x.id) === id);
            return b ? b.name : '';
        },
        addPageSelectedPermissionCount() {
            const base = Array.isArray(this.ruleForm.Permissions) ? this.ruleForm.Permissions.length : 0;
            const dept = Array.isArray(this.ruleForm.AllowedDepartmentIds) ? this.ruleForm.AllowedDepartmentIds.length : 0;
            const pd = Array.isArray(this.ruleForm.AllowedPatientDispenseDepartmentIds) ? this.ruleForm.AllowedPatientDispenseDepartmentIds.length : 0;
            return base + dept + pd;
        },
        totalPages() {
            return Math.ceil(this.pages / this.pageSize);
        },
        totalPagesT() {
            return Math.ceil(this.pagesT / this.pageSizeT);
        },
    },

    watch: {
        '$route'(to) {
            if (!to) return;
            if (to.name === 'BranchUsersAdd') {
                this.state = 0;
                this.ClearForm(this.ruleForm);
            } else if (to.name === 'BranchUsers' && this.state === 0) {
                this.GetInfo();
            }
        },
    },

    data() {
        const requirePermissionsValidator = (rule, value, callback) => {
            if (this.getEffectivePermissions(value, this.ruleForm.AllowedDepartmentIds).length === 0) {
                callback(new Error('الرجاء اختيار صلاحية واحدة على الأقل'));
                return;
            }

            callback();
        };

        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            pageNoT: 1,
            pageSizeT: 10,
            pagesT: 0,
            state: 0,
            Search: '',
            statusFilter: 0,

            ScreenTitle: 'حسابات مستخدمي المركز',
            ScreenTitleSingle: 'مستخدم',
            ScreenTitleSingleAl: 'المستخدم',

            Info: [],
            InfoT: [],
            Statistics: [],

            SelectedItem: '',

            ruleForm: {
                Id: '',
                Name: '',
                LoginName: '',
                Email: '',
                Phone: '',
                Image: '',
                ImageName: '',
                Permissions: [],
                AllowedDepartmentIds: [],
                AllowedPatientDispenseDepartmentIds: [],
                BranchesId: null,
            },
            departmentList: [],

            // ── اختيار المرفق (مدير النظام وإدارة الصيدلة) ──
            // مستخدم المرفق لا يرى هذا الاختيار، ومرفقه يُؤخذ من حسابه في الخادم.
            branchList: [],
            selectedBranchId: null,
            permissionGroups: [
                {
                    title: 'طلبات الأدوية',
                    options: [
                        { key: 'medicine_orders.view', label: 'عرض طلبات الأدوية' },
                        { key: 'medicine_orders.create', label: 'إنشاء/إرسال طلبات الأدوية' },
                        { key: 'medicine_orders.psychotropic', label: 'طلب أصناف مؤثرات عقلية (حسب تصنيف الصنف)' },
                        { key: 'medicine_orders.narcotic', label: 'طلب أصناف مخدرة (حسب تصنيف الصنف)' },
                    ],
                },
                {
                    title: 'الاستلام والإرجاع والتالف',
                    options: [
                        { key: 'receipt_verification.view', label: 'عرض محاضر الاستلام' },
                        { key: 'receipt_verification.verify', label: 'اعتماد/تأكيد الاستلام' },
                        { key: 'return_orders.view', label: 'عرض أوامر الإرجاع' },
                        { key: 'return_orders.create', label: 'إنشاء أوامر الإرجاع' },
                        { key: 'damage_reports.view', label: 'عرض تقارير التالف' },
                        { key: 'damage_reports.create', label: 'إنشاء تقارير التالف' },
                    ],
                },
                {
                    title: 'الطلبات الخاصة والفائض',
                    options: [
                        { key: 'non_formulary.view', label: 'عرض الطلبات غير النمطية' },
                        { key: 'non_formulary.create', label: 'إنشاء الطلبات غير النمطية' },
                        { key: 'product_addition.view', label: 'عرض طلبات إضافة المنتجات' },
                        { key: 'product_addition.create', label: 'تقديم طلبات إضافة منتجات' },
                        { key: 'surplus_requests.view', label: 'عرض طلبات الفائض' },
                        { key: 'surplus_requests.create', label: 'إنشاء طلبات الفائض' },
                        { key: 'national_formulary_portfolio.view', label: 'عرض نطاق القائمة النمطية للمرفق' },
                        { key: 'national_formulary_portfolio.request', label: 'طلب اعتماد أصناف ضمن القائمة النمطية' },
                    ],
                },
                {
                    title: 'التدوير والجرد والتنبيهات',
                    options: [
                        { key: 'rotation_transfers.view', label: 'عرض عمليات التدوير' },
                        { key: 'rotation_transfers.receive', label: 'تنفيذ/استلام التدوير' },
                        { key: 'inventory_counts.view', label: 'عرض الجرد (قراءة فقط)' },
                        { key: 'inventory_counts.create', label: 'فتح جلسات جرد وإرسالها للمراجعة' },
                        { key: 'inventory_counts.warehouse_lines', label: 'أمين مخزن: إضافة/تعديل أصناف كل الأقسام' },
                        { key: 'inventory_counts.department_lines', label: 'رئيس قسم: إدخال كميات قسمه فقط' },
                        { key: 'inventory_counts.approve', label: 'اعتماد وترحيل الجرد' },
                        { key: 'inventory_alerts.view', label: 'عرض تنبيهات المخزون' },
                        { key: 'notifications', label: 'استقبال الإشعارات' },
                    ],
                },
                {
                    title: 'أقسام المرفق والصرف الداخلي',
                    options: [
                        { key: 'facility_departments.view', label: 'عرض أقسام المرفق' },
                        { key: 'facility_departments.manage', label: 'إدارة أقسام المرفق' },
                        { key: 'facility_departments.issue', label: 'الصرف لكل أقسام المرفق' },
                    ],
                },
                {
                    title: 'صرف الدواء للمريض',
                    options: [
                        { key: 'patient_dispense.view', label: 'عرض فواتير الصرف للمرضى' },
                        { key: 'patient_dispense.create', label: 'الصرف للمرضى من كل أقسام المرفق' },
                        { key: 'patient_dispense.cancel', label: 'إلغاء فاتورة صرف وإعادة الكميات' },
                    ],
                },
            ],
            rules: {
                Name: this.$helper.Required(),
                Phone: this.$helper.Phone(),
                Permissions: [{ validator: requirePermissionsValidator, trigger: 'change' }],
                LoginName: [
                    { required: true, message: 'الرجاء إدخال اسم الدخول', trigger: 'blur' },
                    { required: true, pattern: /^[A-Za-z][A-Za-z0-9]*(\.[A-Za-z][A-Za-z0-9]*)*$/, message: 'الرجاء إدخال اسم الدخول بطريقة صحيحة', trigger: 'blur' },
                ],
            },
        };
    },

    methods: {
        normalizePermissions(permissions) {
            if (!Array.isArray(permissions)) {
                return [];
            }

            return [...new Set(permissions.filter((x) => !!x))];
        },

        departmentPermissionKey(id) {
            return `facility_departments.issue.department.${id}`;
        },

        /** تقييد الصرف للمريض بقسم بعينه — مفتاح مستقل عن الصرف الداخلي للأقسام. */
        patientDispenseDepartmentKey(id) {
            return `patient_dispense.department.${id}`;
        },

        getEffectivePermissions(
            permissions = this.ruleForm.Permissions,
            allowedDepartmentIds = this.ruleForm.AllowedDepartmentIds,
            allowedPatientDispenseDepartmentIds = this.ruleForm.AllowedPatientDispenseDepartmentIds
        ) {
            const list = this.normalizePermissions(permissions);
            (allowedDepartmentIds || []).forEach((id) => {
                const numericId = Number(id);
                if (numericId > 0) {
                    list.push(this.departmentPermissionKey(numericId));
                }
            });
            (allowedPatientDispenseDepartmentIds || []).forEach((id) => {
                const numericId = Number(id);
                if (numericId > 0) {
                    list.push(this.patientDispenseDepartmentKey(numericId));
                }
            });
            return [...new Set(list)];
        },

        parsePermissions(permissions) {
            if (!permissions) {
                return [];
            }

            try {
                const parsed = JSON.parse(permissions);
                return this.normalizePermissions(Array.isArray(parsed) ? parsed : []);
            } catch {
                return [];
            }
        },

        extractAllowedDepartmentIds(permissions) {
            return this.parsePermissions(permissions)
                .filter((x) => x && x.indexOf('facility_departments.issue.department.') === 0)
                .map((x) => Number(x.replace('facility_departments.issue.department.', '')))
                .filter((x) => Number.isFinite(x) && x > 0);
        },

        extractAllowedPatientDispenseDepartmentIds(permissions) {
            return this.parsePermissions(permissions)
                .filter((x) => x && x.indexOf('patient_dispense.department.') === 0)
                .map((x) => Number(x.replace('patient_dispense.department.', '')))
                .filter((x) => Number.isFinite(x) && x > 0);
        },

        /** المفاتيح المقيَّدة بالأقسام تُدار بقوائم منفصلة، فتُنزع من قائمة الصلاحيات العامة. */
        stripDepartmentPermissionKeys(permissions) {
            return this.parsePermissions(permissions)
                .filter((x) => !(x && (x.indexOf('facility_departments.issue.department.') === 0
                    || x.indexOf('patient_dispense.department.') === 0)));
        },

        loadDepartmentList() {
            // الوزارة تمرّر المرفق صراحةً؛ ومستخدم المرفق يمرّر null فيحسمه الخادم من حسابه.
            return this.$http.GetAllFacilityDepartments(this.selectedBranchId || null)
                .then((response) => {
                    this.departmentList = response.data.info || [];
                })
                .catch(() => {
                    this.departmentList = [];
                });
        },

        loadBranchList() {
            return this.$http.GetAllBranches()
                .then((response) => {
                    this.branchList = (response.data && response.data.info) || [];
                })
                .catch(() => {
                    this.branchList = [];
                });
        },

        /**
         * تغيير المرفق: تُعاد تحميل الأقسام والقائمة معاً.
         * والأقسام المختارة تُفرَّغ — فقسم مرفقٍ آخر لا يعني شيئاً هنا،
         * وتركها يُنتج حساباً بصلاحية قسم لا وجود له في مرفقه.
         */
        async onBranchChange() {
            this.ruleForm.BranchesId = this.selectedBranchId;
            this.ruleForm.AllowedDepartmentIds = [];
            this.ruleForm.AllowedPatientDispenseDepartmentIds = [];
            this.departmentList = [];
            this.Info = [];
            this.pages = 0;

            if (!this.selectedBranchId) return;

            await this.loadDepartmentList();
            if (!this.isAddPage) this.GetInfo();
        },

        buildPayload() {
            return {
                ...this.ruleForm,
                Id: Number(this.ruleForm.Id || 0),
                Permissions: JSON.stringify(this.getEffectivePermissions()),
            };
        },

        clearValidationState() {
            ['addRuleForm', 'editRuleForm'].forEach((formRef) => {
                if (this.$refs[formRef]) {
                    this.$refs[formRef].clearValidate(['Permissions']);
                }
            });
        },

        getUserTypeLabel(userType) {
            if (Number(userType) === 2) {
                return 'مسؤول مرفق صحي';
            }

            if (Number(userType) === 6) {
                return 'مسؤول قسم مرفق صحي';
            }

            if (Number(userType) === 5) {
                return 'مستخدم مرفق بصلاحيات مخصصة';
            }

            return 'غير محدد';
        },

        getPermissionLabel(permissionKey) {
            if (permissionKey && permissionKey.indexOf('facility_departments.issue.department.') === 0) {
                const id = Number(permissionKey.replace('facility_departments.issue.department.', ''));
                const department = this.departmentList.find((x) => Number(x.id) === id);
                return department ? `الصرف لقسم: ${department.name}` : permissionKey;
            }
            for (const group of this.permissionGroups) {
                const match = group.options.find((item) => item.key === permissionKey);
                if (match) {
                    return match.label;
                }
            }

            return permissionKey;
        },

        getPermissionLabels(permissions) {
            return this.parsePermissions(permissions).map((permission) => this.getPermissionLabel(permission));
        },

        canManageItem(item) {
            if (!this.canManageBranchUsersUi() || !item || !this.loginDetails) {
                return false;
            }

            return Number(item.userType) === 5 && Number(item.id) !== Number(this.loginDetails.id);
        },

        canViewTransactions(item) {
            if (!item || !this.loginDetails) {
                return false;
            }

            return Number(item.userType) === 5 && Number(item.branchesId) === Number(this.loginDetails.branchesId);
        },

        fillRuleForm(item) {
            this.SelectedItem = item;
            this.ruleForm.Id = item.id;
            this.ruleForm.Name = item.name;
            this.ruleForm.Phone = item.phone;
            this.ruleForm.LoginName = item.loginName;
            this.ruleForm.Email = item.email;
            this.ruleForm.Image = '';
            this.ruleForm.ImageName = '';
            this.ruleForm.Permissions = this.stripDepartmentPermissionKeys(item.permissions);
            this.ruleForm.AllowedDepartmentIds = this.extractAllowedDepartmentIds(item.permissions);
            this.ruleForm.AllowedPatientDispenseDepartmentIds = this.extractAllowedPatientDispenseDepartmentIds(item.permissions);
        },

        ClearForm(form) {
            form.Id = '';
            form.Name = '';
            form.LoginName = '';
            form.Email = '';
            form.Phone = '';
            form.Image = '';
            form.ImageName = '';
            form.Permissions = [];
            form.AllowedDepartmentIds = [];
            form.AllowedPatientDispenseDepartmentIds = [];
            // المرفق المختار لا يُمسح: الوزارة تضيف عدة مستخدمين لمرفق واحد تباعاً،
            // وإعادة اختياره بعد كل حفظ تُتعب وتفتح باب الخطأ.
            form.BranchesId = this.selectedBranchId || null;
            this.SelectedItem = '';
            this.clearValidationState();
        },

        shouldShowDepartmentScope() {
            return this.ruleForm.Permissions.includes('facility_departments.issue') || this.ruleForm.AllowedDepartmentIds.length > 0;
        },

        /** يظهر تقييد الأقسام بمجرد منح أي صلاحية على شاشة الصرف للمريض. */
        shouldShowPatientDispenseScope() {
            return this.ruleForm.Permissions.includes('patient_dispense.view')
                || this.ruleForm.Permissions.includes('patient_dispense.create')
                || this.ruleForm.AllowedPatientDispenseDepartmentIds.length > 0;
        },

        GetInfo(pageNo) {
            this.pageNo = pageNo;
            if (this.pageNo === undefined) {
                this.pageNo = 1;
            }
            if (!this.Search) this.$blockUI.Start();
            this.$http.GetBranchUsers(this.pageNo, this.pageSize, this.Search, this.statusFilter, this.selectedBranchId || null)
                .then((response) => {
                    if (!this.Search) this.$blockUI.Stop();
                    this.Info = response.data.info;
                    this.pages = response.data.count;
                    this.Statistics = response.data.statistics || [];
                })
                .catch(() => {
                    if (!this.Search) this.$blockUI.Stop();
                    this.Info = [];
                    this.pages = 0;
                    this.Statistics = 0;
                });
        },

        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    this.$helper.showSwal('warning');
                    return false;
                }

                const payload = this.buildPayload();
                this.$blockUI.Start();
                this.$http.AddBranchUser(payload)
                    .then((response) => {
                        this.$blockUI.Stop();
                        this.ClearForm(this.ruleForm);
                        if (this.isAddPage) {
                            this.$router.push({ name: 'BranchUsers' });
                        } else {
                            this.GetInfo();
                            this.$helper.DestroyElemntById('Close');
                        }
                        this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                    })
                    .catch((err) => {
                        this.$blockUI.Stop();
                        const msg = err.response && err.response.data ? err.response.data : 'حدت خطاء غير متوقع';
                        this.$helper.ShowMessage('error', 'خطاء بعملية الإضافة', msg);
                    });
            });
        },

        ViewInfo(item) {
            if (!this.canViewTransactions(item)) {
                return;
            }

            this.fillRuleForm(item);
            this.GetUsersTransactionsInfo();
            this.state = 1;
        },

        GetUsersTransactionsInfo(pageNoT) {
            this.pageNoT = pageNoT || 1;
            this.$blockUI.Start();

            this.$http.GetUsersTransactions(this.pageNoT, this.pageSizeT, this.SelectedItem.id)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.InfoT = response.data.info;
                    this.pagesT = response.data.count;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                    this.InfoT = [];
                    this.pagesT = 0;
                });
        },

        OpentEditDialog(item) {
            this.fillRuleForm(item);
            this.clearValidationState();
        },

        submitEditForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    this.$helper.showSwal('warning');
                    return false;
                }

                const payload = this.buildPayload();
                this.$blockUI.Start();
                this.$http.EditBranchUser(payload)
                    .then((response) => {
                        this.$blockUI.Stop();
                        this.GetInfo();
                        this.ClearForm(this.ruleForm);
                        this.$helper.DestroyElemntById('CloseEdit');
                        this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                    })
                    .catch((err) => {
                        this.$blockUI.Stop();
                        const msg = err.response && err.response.data ? err.response.data : 'حدت خطاء غير متوقع';
                        this.$helper.ShowMessage('error', 'خطاء بعملية التعديل', msg);
                    });
            });
        },

        ChangeStatus(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: ' هـل انت متأكد من عملية تغير حالة العرض  ؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
                confirmButtonText: 'تأكيد العملية',
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.ChangeStatusUsers(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo();
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            const msg = err.response && err.response.data ? err.response.data : 'حدت خطاء غير متوقع';
                            this.$helper.ShowMessage('error', 'خطاء بعملية التعديل', msg);
                        });
                }
            });
        },

        ResetPassword(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: ' هـل انت متأكد من عملية تهيئة كلمة المرور   ؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
                confirmButtonText: 'تأكيد العملية',
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.ResetPasswordUsers(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo();
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            const msg = err.response && err.response.data ? err.response.data : 'حدت خطاء غير متوقع';
                            this.$helper.ShowMessage('error', 'خطاء بعملية التعديل', msg);
                        });
                }
            });
        },

        Delete(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: ' هـل انت متأكد من عملية الحذف  ؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
                confirmButtonText: 'تأكيد العملية',
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.DeleteUsers(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo();
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            const msg = err.response && err.response.data ? err.response.data : 'حدت خطاء غير متوقع';
                            this.$helper.ShowMessage('error', 'خطاء بعملية الحذف', msg);
                        });
                }
            });
        },

        SelectImage(file) {
            if (!file) {
                this.$helper.ShowMessage('error', 'خطاء بالعملية', 'يرجى اختيار ملف');
                return;
            }

            let str = file.type;
            str = str.substring(0, 5);

            if (str !== 'image') {
                this.$helper.ShowMessage('error', 'خطاء بالعملية', 'الرجاء التأكد من نوع الملف');
                return;
            }

            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                this.ruleForm.ImageName = file.name;
                this.ruleForm.Image = reader.result;
            };
        },

        Back() {
            this.SelectedItem = '';
            this.InfoT = [];
            this.pagesT = 0;
            this.state = 0;
        },

        goAddUser() {
            if (!this.canCreateBranchUsersUi()) return;
            if (!this.selectedBranchId) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'اختر المرفق أولاً.');
                return;
            }
            // المرفق يسافر في الرابط: صفحة الإضافة مكوّن يُعاد بناؤه،
            // فلو بقي في الذاكرة وحدها ضاع عند الانتقال وفشل الحفظ بلا سبب ظاهر.
            this.$router.push({ name: 'BranchUsersAdd', query: { branchId: this.selectedBranchId } });
        },

        cancelAddUser() {
            this.$router.push({ name: 'BranchUsers' });
        },

        permissionGroupSelectedCount(group) {
            if (!group || !Array.isArray(group.options)) return 0;
            const set = new Set(this.ruleForm.Permissions || []);
            return group.options.filter((o) => set.has(o.key)).length;
        },
    },
};
